import { useState, useEffect } from "react";
import { Calculator } from "lucide-react";
import { api } from "@/lib/api";
import { inr, fmtDate } from "@/lib/format";
import { PageHeader, Loading, EmptyState, StatusBadge } from "@/components/common";
import { Card } from "@/components/ui/card";

export default function PhysioSettlement() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/settlements").then((r) => setItems(r.data.items)).finally(() => setLoading(false));
  }, []);

  if (loading) return <Loading />;

  return (
    <div>
      <PageHeader title="My Settlement" subtitle="Your monthly revenue share & payouts" testid="physio-settlement-page" />
      {items.length === 0 ? (
        <EmptyState icon={Calculator} title="No settlements yet" subtitle="Your monthly settlement will appear here once generated by the owner." />
      ) : (
        <div className="grid gap-3 lg:grid-cols-2">
          {items.map((s) => (
            <Card key={s.id} className="p-5" data-testid={`my-settlement-${s.month}`}>
              <div className="flex items-center justify-between mb-2">
                <p className="font-display font-bold text-slate-800">{s.month}</p>
                <StatusBadge status={s.status} />
              </div>
              <div className="grid grid-cols-2 gap-2 text-sm">
                <div className="flex justify-between border-b border-slate-100 py-1.5"><span className="text-slate-500">Visits</span><span>{s.total_visits}</span></div>
                <div className="flex justify-between border-b border-slate-100 py-1.5"><span className="text-slate-500">Gross</span><span className="tabular-nums">{inr(s.gross_revenue)}</span></div>
                <div className="flex justify-between border-b border-slate-100 py-1.5"><span className="text-slate-500">My Share</span><span className="tabular-nums text-bk-green">{inr(s.physio_share)}</span></div>
                <div className="flex justify-between border-b border-slate-100 py-1.5"><span className="text-slate-500">Petrol (mine)</span><span className="tabular-nums text-bk-danger">-{inr(s.physio_petrol_share)}</span></div>
                <div className="flex justify-between border-b border-slate-100 py-1.5"><span className="text-slate-500">Net</span><span className="tabular-nums font-semibold">{inr(s.physio_net)}</span></div>
                <div className="flex justify-between border-b border-slate-100 py-1.5"><span className="text-slate-500">Paid</span><span className="tabular-nums">{inr(s.paid_amount)}</span></div>
              </div>
              <div className="flex justify-between mt-3 pt-2 border-t-2 border-slate-200">
                <span className="font-semibold text-slate-800">Balance Payable</span>
                <span className="font-display font-extrabold text-lg text-bk-green tabular-nums">{inr(s.final_balance)}</span>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
